import { Retailer } from './retailer';
import { SkuPrice } from './sku-price';

export class SkuPriceDto {
    public startDate: string;
    public endDate: string;
    public periodType: string;
    public pricePer: string;
    public currency: string;
    public results: PriceDto[];
}

export class PriceDto {
    public id: number;
    public itemId: number;
    public results: SkuPrice[];
    public retailers: Retailer[];
}
